import { all } from 'redux-saga/effects';
import documentsByPolicyId from './documents-by-policy-id';
import sendDocuments from './send-documents';
export default function* policyDocumentsSaga() {
    yield all([documentsByPolicyId, sendDocuments]);
}
